import z from 'zod';
import path from 'path';
import file from '../../../utils/file';
import api from '../../api';
import models from '../../../models';
import { createCallToolResult, createTextContent } from '../output-parser';
import type { WrappedRegisterToolFuncType } from '../tool-definition';

const name = 'test-action';

const inputSchema = models.tool.testActionInput.omit({ outputFile: true });

const config = {
  description: 'Test an action',
  inputSchema,
};

const handler = async (input: z.infer<typeof config.inputSchema>) => {
  const { bookPath, inputList, actionTitle } = input;
  const bookYamlStr = bookPath && (await file.readFile(bookPath));
  const bookName = bookPath && path.basename(bookPath, '.yaml');
  const result = await api.testAction({
    bookYamlStr,
    bookName,
    inputList,
    actionTitle,
  });

  return createCallToolResult({
    contentBlocks: [createTextContent(JSON.stringify(result, null, 2))],
  });
};

export const setup = (register: WrappedRegisterToolFuncType) => {
  register(name, config, handler);
};

export default { setup };
